import { PriceCardSubscriptionGateway } from '@price-card/gateways/subscription.gateway';
import { formatGetHeaders, formatPostHeaders, formatPutHeaders } from '@configurations/api-configuration';
import { environment } from '../../../../../environments/environment';
import { Subscription } from '@price-card/models/subscription.model';
import { SubscriptionMapper } from '@secondaries/price-card/gateways/subscription/subscription.mapper';
import { PriceCardSubscription } from '@secondaries/price-card/gateways/subscription/price-card-subscription.model';

export class ApiPriceCardSubscriptionGateway implements PriceCardSubscriptionGateway {
  private readonly mapper = new SubscriptionMapper();
  private readonly priceCardSubscriptionApiUrl = `${environment.backend_url}/api/v1/price-card/subscription`;

  async retrieveAll(): Promise<Subscription[]> {
    try {
      const response = await fetch(`${this.priceCardSubscriptionApiUrl}`, await formatGetHeaders());
      const jsonResponse = await response.json();
      return this.mapper.mapArrayToDomainModel(jsonResponse);
    } catch (error) {
      throw new Error('Error retrieving price card subscriptions' + error);
    }
  }

  async subscribeByPriceZoneAndTechnologyAndCommercialOperationDate(
    subscription: Subscription): Promise<Subscription> {
    const URL = `${this.priceCardSubscriptionApiUrl}`;
    const subscriptionToPost: PriceCardSubscription = this.mapper.mapToDTO(subscription);
    const response: Response = await fetch(URL, await formatPostHeaders(subscriptionToPost));

    if(response.status !== 200){
      throw new Error('Error while subscribing price card: ' + response.statusText);
    }
    const jsonResponse = await response.json();
    return this.mapper.mapToDomainModel(jsonResponse);
  }

  async unsubscribeById(subscriptionId: number): Promise<void> {
    try {
      const response = await fetch(`${this.priceCardSubscriptionApiUrl}/disable?subscriptionId=${subscriptionId}`, await formatPutHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error unsubscribing to price card' + error);
    }
  }
}
